export default __webpack_public_path__ + "static/media/Gifti+Global+SND.bb642c52.png";